export const INTRODUCING_VIDEO = 'https://cdn.taffi.co/public/video/introducing-video.mp4';
export const SERVICE_WORKER_FILE_NAME = 'service-worker.js';
export const DYNAMIC_LAYOUT_PARAM = 'dynamicLayoutVersion';
